import widgetInfo from './widgetInfo';
import layout from './layout';
import modalSettings from './modalSettings';
import offSiteData from './offSiteData';
import userProfile from './userProfile';
import ctaCardItemlist from './ctaCardItemlist';

const root = {
	widgetInfo,
	layout,
	modalSettings,
	offSiteData,
	userProfile,
	ctaCardItemlist
};

export default root;
